import React, {ReactElement} from 'react';
import {APP_VERSION} from 'env';
import {Container, Version} from './style';

export const AppVersion = (): ReactElement => {
  return (
    <Container>
      <Version>{APP_VERSION}</Version>
    </Container>
  );
};
